<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>PF FFP Growth Formulas</h4>
      <p>Dashboard for the PF FFP Growth Formulas</p>
    </div>
    <div class="action-container">
      <button *ngIf="userProfile.IsAdmin" type="submit" class="btn btn-danger" (click)="triggerBackfill()">Backfill</button>&nbsp;
      <button type="submit" class="btn btn-primary" (click)="refreshData()">Refresh</button>&nbsp;
      <a
        href="javascript:void(0)"
        class="topbar-item"
        (click)="exportExcel()"
        placement="top-right"
        container="body"
        ngbTooltip="Export to Excel"
        aria-label="Export to Excel"
      >
        <span class="far fa-file-excel fa-lg"></span>
      </a>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main mt-3">
    <div class="mb-2">
      <strong>Total</strong><br>
      Baseline 1: {{ total.baseline1 }}<br>
      Baseline 2: {{ total.baseline2 }}<br>
      Baseline 3: {{ total.baseline3 }}<br>
      Growth Coefficients: {{ total.growthCoefficients }}<br>
    </div>
    <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
    <ag-grid-angular
      #agGrid
      id="ViewGrid"
      style="width: 100%; height: 540px"
      class="ag-theme-balham"
      [masterDetail]="true"
      [gridOptions]="gridOptions"
      [rowData]="rowData"
      [excelStyles]="headerStyle"
      [pagination]="true"
      rowSelection="multiple"
      (gridReady)="onGridReady($event)"
      (filterChanged)="onFilterChanged($event)">
    </ag-grid-angular>
  </div>
</div>
